<template>
  <div class="text text-imprint" id="skipTo">
    <div v-html="getTextImprint"></div>
    <router-link :to="{ name: 'chapter'}">zurück zur Check-App</router-link>
  </div>
</template>

<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'imprint',

  computed: {
    ...mapGetters([
      'getTextImprint'
    ]),
  }
}
</script>